export default __webpack_public_path__ + "static/media/world_map2.898739c4.jpg";